module.exports = __webpack_public_path__ + "static/img/1.a214f47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/1.png
// module id = hjcN
// module chunks = 0